import styled, { css, keyframes } from 'styled-components';

export const Boxes = styled.div`
  position: relative;
  display: inline-flex;
  gap: 8px;
`;

const blink = keyframes`
  50% { opacity: 0; }
`;

export const Box = styled.div<{ isActive: boolean; isFilled: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 56px;
  border: 2px solid var(--color-border-primary);
  border-radius: 8px;
  background-color: var(--color-bg-raised);
  color: var(--color-text-primary);
  font-family: 'Courier New', monospace;
  font-size: 28px;
  font-weight: 700;

  ${(props) =>
    props.isActive &&
    css`
      border-color: var(--color-border-focus);
    `}

  ${(props) =>
    !props.isFilled &&
    css`
      color: var(--color-text-muted);
    `}
`;

// Where the next character goes
export const Caret = styled.div`
  width: 2px;
  height: 28px;
  background-color: var(--color-border-focus);
  animation: ${blink} 1s step-end infinite;
`;

// The real input, over the boxes: it takes the typing, pasting and focus,
// while the boxes show what's in it.
export const OverlayInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: transparent;
  caret-color: transparent;
  font-size: 16px;
  cursor: text;
`;
